/**
 * Get boarding offset in minutes before operation time.
 * Dublin (DUB): -35 min if seats <= 230, -50 min if seats > 230. Uses boardingOffsetMinutes from API when available.
 * All other airports: standard -45 min.
 */
export const getBoardingOffsetMinutes = (flightData, iata) => {
    if (iata !== 'DUB') return 45;
    if (flightData?.boardingOffsetMinutes != null) return flightData.boardingOffsetMinutes;
    const seats = flightData?.seats ?? flightData?.seatCapacity ?? 0;
    return seats <= 230 ? 35 : 50;
};
